module.exports = __webpack_public_path__ + "static/media/meter-other.82ad5d0d.svg";